import { Users, UserCog, Building2, Sparkles } from "lucide-react";

const Bar = ({ icon: Icon, label, used, limit }) => {
  const pct = limit ? Math.min(100, Math.round((used / limit) * 100)) : 0;
  const near = pct >= 80 && pct < 100;
  const full = pct >= 100;
  const color = full ? "bg-red-500" : near ? "bg-amber-500" : "bg-emerald-500";
  const textColor = full ? "text-red-600" : near ? "text-amber-600" : "text-slate-600";
  return (
    <div data-testid={`usage-${label.en}`} className="flex-1 min-w-[150px]">
      <div className="flex items-center justify-between mb-1">
        <span className="inline-flex items-center gap-1.5 text-xs font-semibold text-slate-500">
          <Icon className="h-3.5 w-3.5" /> {label.ar}
        </span>
        <span className={`text-xs font-bold font-mono-nums ${textColor}`} dir="ltr">
          {used} / {limit}
        </span>
      </div>
      <div className="h-2 rounded-full bg-slate-100 overflow-hidden">
        <div className={`h-full rounded-full transition-all ${color}`} style={{ width: `${Math.max(pct, 4)}%` }} />
      </div>
    </div>
  );
};

export const UsageMeter = ({ subscription }) => {
  if (!subscription || subscription.is_platform_owner) return null;
  const rows = [
    { key: "employees", icon: Users, label: { ar: "الموظفون", en: "employees" }, used: subscription.employees_used, limit: subscription.employee_limit },
    { key: "users", icon: UserCog, label: { ar: "المستخدمون", en: "users" }, used: subscription.users_used, limit: subscription.users_limit },
    { key: "branches", icon: Building2, label: { ar: "الفروع", en: "branches" }, used: subscription.branches_used, limit: subscription.branches_limit },
  ].filter((r) => r.limit != null); // hide unlimited (enterprise)

  if (rows.length === 0) return null;
  const anyFull = rows.some((r) => r.limit && r.used >= r.limit);
  const anyNear = rows.some((r) => r.limit && r.used / r.limit >= 0.8);

  return (
    <div data-testid="usage-meter" className="mb-5 rounded-2xl border border-slate-200 bg-white p-4">
      <div className="flex items-center justify-between mb-3 flex-wrap gap-2">
        <span className="text-sm font-heading font-bold text-slate-700">استهلاك باقتك</span>
        {(anyFull || anyNear) && (
          <a href="/pricing" data-testid="usage-upgrade-link"
            className="inline-flex items-center gap-1 rounded-full h-7 px-3 text-xs font-bold bg-gradient-to-l from-blue-600 to-indigo-600 text-white hover:opacity-90 transition">
            <Sparkles className="h-3 w-3" /> {anyFull ? "وصلت للحد — رقِّ باقتك" : "ترقية"}
          </a>
        )}
      </div>
      <div className="flex items-start gap-5 flex-wrap">
        {rows.map((r) => (
          <Bar key={r.key} icon={r.icon} label={r.label} used={r.used ?? 0} limit={r.limit} />
        ))}
      </div>
    </div>
  );
};
